import { useState } from 'react';
import { Link } from 'react-router-dom';
import { agencies } from '../data/agenciesData';

export default function Agencies() {
  const [cityFilter, setCityFilter] = useState('all');
  const [specialtyFilter, setSpecialtyFilter] = useState('all');

  const allCities = [...new Set(agencies.flatMap(a => a.cities))].sort();
  const allSpecialties = [...new Set(agencies.flatMap(a => a.specialties))].sort();

  const filtered = agencies.filter(a => {
    const cityOk = cityFilter === 'all' || a.cities.includes(cityFilter);
    const specOk = specialtyFilter === 'all' || a.specialties.includes(specialtyFilter);
    return cityOk && specOk;
  });

  const filterBtn = (active) => ({
    padding: '5px 14px', borderRadius: 'var(--radius-sm)',
    border: `1.5px solid ${active ? 'var(--color-primary)' : 'var(--color-border)'}`,
    cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600,
    fontFamily: 'var(--font-body)', letterSpacing: '0.04em',
    background: active ? 'var(--color-primary)' : 'var(--color-bg-white)',
    color: active ? '#fafaf8' : 'var(--color-text-muted)',
    transition: 'all 0.2s',
  });

  return (
    <div className="page-content">
      <div className="container">
        <span className="gold-tag">Partenaires</span>
        <h1>Agences partenaires</h1>
        <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem' }}>
          Nos partenaires francophones et anglophones en Israël. Sélectionnés pour leur expertise et leur sérieux.
        </p>

        {/* Filtres */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--color-text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', minWidth: 80 }}>Ville</span>
            <button style={filterBtn(cityFilter === 'all')} onClick={() => setCityFilter('all')}>Toutes</button>
            {allCities.map(c => <button key={c} style={filterBtn(cityFilter === c)} onClick={() => setCityFilter(c)}>{c}</button>)}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--color-text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', minWidth: 80 }}>Spécialité</span>
            <button style={filterBtn(specialtyFilter === 'all')} onClick={() => setSpecialtyFilter('all')}>Toutes</button>
            {allSpecialties.map(s => <button key={s} style={filterBtn(specialtyFilter === s)} onClick={() => setSpecialtyFilter(s)}>{s}</button>)}
          </div>
        </div>

        <div className="grid-2">
          {filtered.map(agency => (
            <div key={agency.id} style={{ background: 'var(--color-bg-white)', borderRadius: 'var(--radius-lg)', padding: '2rem', border: '1px solid var(--color-border)', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h3 style={{ margin: 0, marginBottom: '0.25rem', fontSize: '1.15rem' }}>{agency.name}</h3>
                  <div style={{ fontSize: '0.78rem', color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{agency.city}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-accent)' }}>{agency.rating}/5</div>
                  <div style={{ fontSize: '0.72rem', color: 'var(--color-text-muted)' }}>{agency.transactionsCount}+ transactions</div>
                </div>
              </div>

              <p style={{ margin: 0, fontSize: '0.875rem', lineHeight: 1.7, color: 'var(--color-text-muted)' }}>{agency.description}</p>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                {agency.specialties.map(s => <span key={s} className="badge badge-blue">{s}</span>)}
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                {agency.languages.map(l => <span key={l} className="badge badge-neutral">{l}</span>)}
              </div>

              <div style={{ borderTop: '1px solid var(--color-border)', paddingTop: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: '0.82rem', color: 'var(--color-text-muted)' }}>{agency.yearsActive} ans d'expérience</div>
                <Link to="/accompagnement" className="btn btn-primary btn-sm">Contacter via nous</Link>
              </div>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: '4rem 0', color: 'var(--color-text-muted)' }}>
            <p>Aucune agence ne correspond à ces filtres.</p>
            <button className="btn btn-outline" onClick={() => { setCityFilter('all'); setSpecialtyFilter('all'); }}>Réinitialiser</button>
          </div>
        )}

        <div style={{ background: 'var(--color-primary)', borderRadius: 'var(--radius-lg)', padding: '2.5rem', marginTop: '3rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
          <div>
            <h3 style={{ color: '#fafaf8', margin: 0, marginBottom: '0.5rem' }}>Vous êtes une agence ?</h3>
            <p style={{ color: 'rgba(250,250,248,0.72)', margin: 0 }}>Rejoignez notre réseau de partenaires francophones et accédez à nos utilisateurs qualifiés.</p>
          </div>
          <Link to="/accompagnement" className="btn btn-accent">Rejoindre le réseau</Link>
        </div>
      </div>
    </div>
  );
}
